import { IconName } from 'helpers/renderIcon';
import { IActionData } from 'models/common';
import { IOffice } from './office';
import { IShopProfile } from './shopprofile';
import { IShopShippingOption } from './shopshippingoption';

export interface IManageShop<TShop = IShopProfile> extends IActionData {
	shop?: TShop;
	isEditMode?: boolean;
	picture?: string;
}

export interface IManageShopAction {
	type: string;
	payload?: {
		message?: any;
		shop?: IShopProfile;
		shippingOptions?: Array<IShopShippingOption>;
		isEditMode?: boolean;
		offices?: IOffice[];
	};
}

interface IShopManageLink {
	title: string;
	slug: string;
	icon?: IconName;
	inHeader?: boolean;
	inSettings: boolean;
	isShopLink?: boolean;
	inAdminOnly?: boolean;
}

export const manageShopLinksAdmin: IShopManageLink[] = [
	{
		slug: '',
		title: 'Notifications_Label_Profile',
		inHeader: true,
		inSettings: false,
		isShopLink: true,
	},
	{
		slug: 'appointments',
		title: 'Portal_LeftSideMenu_ManageShop_Appointments',
		icon: 'appointments',
		inHeader: true,
		inSettings: false,
	},
	{
		slug: 'worktime',
		title: 'Shop_ManageShop_Location_Title_WorkTime',
		icon: 'worktime',
		inHeader: true,
		inSettings: false,
	},
	{
		slug: 'edit/locations',
		title: 'Portal_LeftSideMenu_ManageShop_Locations',
		inHeader: false,
		inSettings: true,
	},
	{
		slug: 'edit/members',
		title: 'Portal_LeftSideMenu_ManageShop_Members',
		inHeader: false,
		inSettings: true,
	},
	{
		slug: 'edit/customers',
		title: 'User_ShopCard_Customers',
		icon: 'customers',
		inHeader: true,
		inSettings: false,
	},
	{
		slug: 'edit/services',
		title: 'User_ShopCard_Services_EditServices',
		icon: 'edit2',
		inHeader: true,
		inSettings: true,
	},
	{
		slug: 'edit/orders',
		title: 'Portal_LeftSideMenu_ManageShop_Orders',
		icon: 'orders',
		inHeader: false,
		inSettings: false,
		inAdminOnly: true,
	},
	{
		slug: 'edit/analytics',
		title: 'User_ShopCard_Analytics',
		icon: 'analytics',
		inHeader: true,
		inSettings: false,
	},
	{
		slug: 'edit/shipping',
		title: 'Portal_LeftSideMenu_ManageShop_Shipping',
		inHeader: false,
		inSettings: false,
	},
	{
		slug: 'edit/address',
		title: 'Portal_LeftSideMenu_ManageShop_Address',
		icon: 'open_salon',
		inHeader: false,
		inSettings: false,
	},
	{
		slug: 'edit/promo',
		title: 'Portal_LeftSideMenu_Promotions',
		icon: 'discountBadge',
		inHeader: true,
		inSettings: true,
	},
	{
		slug: 'edit/general',
		title: 'Portal_LeftSideMenu_Account',
		icon: 'edit_profile',
		inHeader: true,
		inSettings: true,
	},
];

export const manageShopLinksMember: IShopManageLink[] = [
	{
		slug: '',
		title: 'Notifications_Label_Profile',
		inHeader: true,
		inSettings: false,
		isShopLink: true,
	},
	{
		slug: 'appointments',
		title: 'Portal_LeftSideMenu_ManageShop_Appointments',
		icon: 'appointments',
		inHeader: true,
		inSettings: false,
	},
	{
		slug: 'worktime',
		title: 'Shop_ManageShop_Location_Title_WorkTime',
		icon: 'worktime',
		inHeader: true,
		inSettings: false,
	},
	{
		slug: 'edit/customers',
		title: 'User_ShopCard_Customers',
		icon: 'customers',
		inHeader: true,
		inSettings: false,
	},
];
